// extracted by mini-css-extract-plugin
export var container = "_dp-0";
export var segment = "_dp-2";
export var segmentActive = "_dp-3";
export var track = "_dp-1";